import { z } from "zod";

export const ACCEPTED_MIME_TYPES = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "image/jpeg",
    "image/png",
];
export const ACCEPTED_EXTENSIONS = ".pdf,.doc,.docx,.jpg,.jpeg,.png";
export const MAX_FILE_SIZE_MB = 10;

const DOCUMENT_FILE = z
    .instanceof(File, { message: "Прикрепите документ" })
    .refine(file => ACCEPTED_MIME_TYPES.includes(file.type), { message: "Допустимые форматы: PDF, DOC, DOCX, JPG, PNG" })
    .refine(file => file.size <= MAX_FILE_SIZE_MB * 1024 * 1024, { message: `Файл не должен превышать ${MAX_FILE_SIZE_MB} МБ` });

// Бэкенд принимает один файл на слот, повторная загрузка в слот недоступна.
export const UPLOAD_SCHEME = z.object({
    files: z
        .array(DOCUMENT_FILE, { message: "Прикрепите документ" })
        .length(1, { message: "Прикрепите документ" }),
});

const FULL_NAME_REGEX = /^[а-яА-ЯёЁa-zA-ZӘәҰұІіҢңҒғҮүҚқӨөҺһ\s-]+$/;

const APPLICANT_FIELDS = {
    full_name: z
        .string({ message: "Впишите ФИО заявителя" })
        .min(2, { message: "Впишите ФИО заявителя" })
        .regex(FULL_NAME_REGEX, { message: "Недопустимый символ" }),
    iin: z.string({ message: "Укажите ИИН" }).length(12, { message: "ИИН состоит из 12 цифр" }),
    country: z.string({ message: "Укажите страну" }).min(2, { message: "Укажите страну" }),
    address: z.string({ message: "Укажите адрес проживания" }).min(2, { message: "Укажите адрес проживания" }),
    phone: z
        .string({ message: "Укажите номер телефона" })
        .regex(/\+7 \(\d{3}\) \d{3} \d{2} \d{2}/, { message: "Укажите номер телефона" }),
    email: z.string({ message: "Укажите email" }).email({ message: "Укажите email" }),
};

const VEHICLE_FIELDS = {
    vehicle_mark_model: z.string({ message: "Укажите марку и модель" }).min(1, { message: "Укажите марку и модель" }),
    vehicle_plate_number: z.string({ message: "Укажите гос. номер" }).min(1, { message: "Укажите гос. номер" }),
};

// «Заявление об организации оценки» (481911).
export const ASSESSMENT_SCHEME = z.object({ ...APPLICANT_FIELDS, ...VEHICLE_FIELDS });

// «Заявление о страховой выплате» (220251). Дата и время события есть в утверждённом
// бланке, но не в ТЗ: дату подставляем из выплаты, время вводит пользователь.
export const PAYOUT_SCHEME = z.object({
    ...APPLICANT_FIELDS,
    ...VEHICLE_FIELDS,
    incident_date: z.string({ message: "Укажите дату события" }).min(1, { message: "Укажите дату события" }),
    incident_time: z
        .string({ message: "Укажите время события" })
        .regex(/^\d{2}:\d{2}$/, { message: "Время в формате ЧЧ:ММ" }),
    recipient_name: z
        .string({ message: "Впишите ФИО получателя" })
        .min(2, { message: "Впишите ФИО получателя" })
        .regex(FULL_NAME_REGEX, { message: "Недопустимый символ" }),
    recipient_iin: z.string({ message: "Укажите ИИН получателя" }).length(12, { message: "ИИН состоит из 12 цифр" }),
    recipient_iban: z
        .string({ message: "Укажите ИИК получателя" })
        .regex(/^KZ[0-9A-Z]{18}$/, { message: "ИИК начинается с KZ и состоит из 20 символов" }),
    recipient_bank_id: z.number({ message: "Выберите банк" }).int({ message: "Выберите банк" }),
});

// doc_isn → схема и заголовок формы.
export const STATEMENT_FORMS = {
    481911: { scheme: ASSESSMENT_SCHEME, title: "Заявление об организации оценки", hasRecipient: false },
    220251: { scheme: PAYOUT_SCHEME, title: "Заявление о страховой выплате", hasRecipient: true },
};
